import React from "react";
import { Link, useLocation } from "react-router-dom";

interface MenuItemsProps {
  isDarkMode: boolean;
  mode?: "horizontal" | "vertical";
}

const MenuItems: React.FC<MenuItemsProps> = ({
  isDarkMode,
  mode = "horizontal"
}) => {
  const location = useLocation();

  const menuItems = [
    { key: "grammar", label: "Grammar", to: "/" },
    { key: "quiz", label: "Quiz", to: "/quiz" },
    { key: "topics", label: "Topics", to: "/topics" },
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav
      className={`custom-menu ${mode} ${isDarkMode ? "dark" : "light"}`}
    >
      {menuItems.map((item) => (
        <Link
          key={item.key}
          to={item.to}
          className={`menu-link ${isActive(item.to) ? "active" : ""}`}
        >
          {item.label}
        </Link>
      ))}
    </nav>
  );
};

export default MenuItems;
